
export class ValidatorAbstract {
  errors = [];
  constructor (formModel) {
    this.formModel = formModel
  }

  get isValid () {
    return !this.errors.length
  }

  validate () {}
}
